export const DYSLEXIC_FONT_TYPE_NAME = 'open-dyslexic-regular';
